/*globals TCApi, $ */
'use strict';

var Block = require('../libs/block');
var PAGE_REFRESH_INTERVAL = 60000; // In ms
var bootstrapDatePickerEvents = 'click keyup change';

module.exports = Block.extend({
    template: '#dashboard',
    range: 0,

    wait_datasets: [{
        label: $('#dashboard').data('average_waiting_time'),
        color: '#003F9E',
        highlightColor: '#003F9E',
        lines: { show: false, steps: false },
        bars: { show: true, align: 'center', fill: 0.9 }
    }],

    delay_datasets: [{
        label: $('#dashboard').data('average_delay'),
        color: '#003F9E',
        highlightColor: '#003F9E',
        lines: { show: false, steps: false },
        bars: { show: true, align: 'center', fill: 0.9 }
    }],

    orders_datasets: [{
        stack: 0,
        label: $('#dashboard').data('open_orders'),
        color: '#003F9E',
        highlightColor: '#003F9E',
        lines: { show: false, steps: false },
        bars: { show: true, align: 'center', fill: 0.9 }
    }, {
        stack: 0,
        label: $('#dashboard').data('loaded_orders'),
        color: '#00B226',
        highlightColor: '#00B226',
        lines: { show: false, steps: false },
        bars: { show: true, align: 'center', fill: 0.9 }
    }, {
        stack: 0,
        label: $('#dashboard').data('not_scheduled'),
        color: '#A91500',
        highlightColor: '#A91500',
        lines: { show: false, steps: false },
        bars: { show: true, align: 'center', fill: 0.9 }
    }],

    chart_options_wait: {
        xaxis: {
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 3,
            color: '#d5d5d5',
            tickLength: 0
        },
        yaxis: {
            position: 'left',
            color: '#d5d5d5',
            minTickSize: 1,
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 3,
            min: 0
        },
        legend: {
            show: false
        },
        grid: {
            hoverable: true,
            clickable: false,
            borderWidth: 0,
            margin: {
                bottom: 30
            }
        }
    },

    chart_options_delay: {
        xaxis: {
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 3,
            color: '#d5d5d5',
            tickLength: 0
        },
        yaxis: {
            position: 'left',
            color: '#d5d5d5',
            minTickSize: 1,
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 3,
            min: 0
        },
        legend: {
            show: false
        },
        grid: {
            hoverable: true,
            clickable: false,
            borderWidth: 0
        }
    },

    chart_options_orders: {
        xaxis: {
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 6,
            color: '#d5d5d5',
            tickLength: 0
        },
        yaxis: {
            position: 'left',
            color: '#d5d5d5',
            minTickSize: 1,
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 3,
            min: 0
        },
        legend: {
            container:$('#orders-legend-container')
        },
        grid: {
            hoverable: true,
            clickable: false,
            borderWidth: 0,
            margin: {
                left: 30,
                bottom: 30
            }
        }
    },

    init: function () {
        $('.orders-chart-button').click(this.ordersChartRangeChanged.bind(this));
        var now = new Date();
        this.date_from_elem = $('#date_from');
        this.date_to_elem = $('#date_to');
        var day = now.getDate().toString(),
            month = (now.getMonth() + 1).toString(),
            year = now.getFullYear().toString();
        this.orders_from = new Date(year + '/01/01');
        this.orders_to = new Date();
        this.date_from_elem.val(year + '-01-01');
        this.date_to_elem.val(year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2));
        this.dateFrom = this.date_from_elem.val();
        this.dateTo = this.date_to_elem.val();

        var self = this;
        this.date_from_elem.on(bootstrapDatePickerEvents, function() {
            console.log('click, keyup, or change here now')
            clearTimeout(self.chartUpdateTimer);
            clearTimeout(self.dateFromTimer);
            self.dateFromTimer = setTimeout(function () {
                if (this.value !== self.dateFrom) {
                    if (this.value !== '') {
                        var localized,
                            parts,
                            day,
                            day_padded,
                            month,
                            month_padded,
                            year;
                        if (this.value.indexOf('-') !== -1) {
                            localized = false;
                            parts = this.value.split('-');
                            day_padded = parts[2];
                            month_padded = parts[1];
                            year = parts[0];
                            day = day_padded.replace(/^[0]+/g, "");
                            month = month_padded.replace(/^[0]+/g, "");
                        } else {
                            localized = true;
                            parts = this.value.split('.');
                            day = parts[0];
                            month = parts[1];
                            year = parts[2];
                            day_padded = ('0' + day).slice(-2);
                            month_padded = ('0' + month).slice(-2);
                        }
                        self.orders_from = new Date(year + '/' + month_padded + '/' + day_padded);
                        if (localized === true) {
                            this.value = day + '.' + month + '.' + year;
                        } else {
                            this.value = year + '-' + month_padded + '-' + day_padded;
                        }
                    } else {
                        self.orders_from = null;
                    }
                    if (self.orders_to && self.orders_from && self.orders_from > self.orders_to) {
                        self.orders_from = self.orders_to;
                        day = self.orders_from.getDate().toString();
                        month = (self.orders_from.getMonth() + 1).toString();
                        year = self.orders_from.getFullYear().toString();
                        if (localized === true) {
                            this.value = day + '.' + month + '.' + year;
                        } else {
                            this.value = year + '-' + month_padded + '-' + day_padded;
                        }
                    }
                    self.dateFrom = this.value;
                    self.chartUpdateTimer = setTimeout(function () {
                        self.updateOrderChart(self.range);
                    }, 500);
                }
            }.bind(this), 1000);
        });
        this.date_to_elem.on(bootstrapDatePickerEvents, function() {
            clearTimeout(self.chartUpdateTimer);
            clearTimeout(self.dateToTimer);
            self.dateToTimer = setTimeout(function () {
                if (this.value !== self.dateTo) {
                    if (this.value !== '') {
                        var localized,
                            parts,
                            day,
                            day_padded,
                            month,
                            month_padded,
                            year;
                        if (this.value.indexOf('-') !== -1) {
                            localized = false;
                            parts = this.value.split('-');
                            day_padded = parts[2];
                            month_padded = parts[1];
                            year = parts[0];
                            day = day_padded.replace(/^[0]+/g, "");
                            month = month_padded.replace(/^[0]+/g, "");
                        } else {
                            localized = true;
                            parts = this.value.split('.');
                            day = parts[0];
                            month = parts[1];
                            year = parts[2];
                            day_padded = ('0' + day).slice(-2);
                            month_padded = ('0' + month).slice(-2);
                        }
                        self.orders_to = new Date(year + '/' + month_padded + '/' + day_padded);
                        if (localized === true) {
                            this.value = day + '.' + month + '.' + year;
                        } else {
                            this.value = year + '-' + month_padded + '-' + day_padded;
                        }
                    } else {
                        self.orders_to = null;
                    }
                    if (self.orders_to && self.orders_from && self.orders_to < self.orders_from) {
                        self.orders_to = self.orders_from;
                        day = self.orders_to.getDate().toString();
                        month = (self.orders_to.getMonth() + 1).toString();
                        year = self.orders_to.getFullYear().toString();
                        if (localized === true) {
                            this.value = day + '.' + month + '.' + year;
                        } else {
                            this.value = year + '-' + month_padded + '-' + day_padded;
                        }
                    }
                    self.dateTo = this.value;
                    self.chartUpdateTimer = setTimeout(function () {
                        self.updateOrderChart(self.range);
                    }, 500);
                }
            }.bind(this), 1000);
        });

        var orderChart = $('#flot-orders-chart');
        var delayChart = $('#flot-delay-chart');
        var waitingChart = $('#flot-waiting-time-chart');
        this.dashboard = $('#dashboard');

        orderChart.bind('plothover', this.showOrdersTooltip.bind(this));
        delayChart.bind('plothover', this.showDelayTooltip.bind(this));
        waitingChart.bind('plothover', this.showWaitTooltip.bind(this));

        if (orderChart.height() !== null) {
            this.updateOrderChart(this.range);
        }
        if (delayChart.height() !== null) {
            this.updateDelayChart();
        }
        if (waitingChart.height() !== null) {
            this.updateWaitChart();
        }

        $('.row-orders-boxes').height($('.col-orders-chart').height());
    },

    updateWaitChart: function() {
        // Another bug in the flot chart: Bar width is not working with only one tick on x-axis, need to create dummies
        TCApi.call('update_wait_chart', {
            args: {
                manufacturer: this.dashboard.data('manufacturer'),
                logisticsprovider: this.dashboard.data('logisticsprovider')
            }
        }).then(function(res) {
            this.chart_options_wait.xaxis.ticks = [[0, ''], [1, res.manufacturer], [2, '']];
            if (res.waiting_time < 0) {
                this.chart_options_wait.yaxis.min = res.waiting_time;
            }
            this.wait_datasets[0].bars.barWidth = 0.5;
            this.wait_datasets[0].data = [[0, null], [1, res.waiting_time], [2, null]];
            $.plot($('#flot-waiting-time-chart'), this.wait_datasets, this.chart_options_wait);
        }.bind(this));
    },

    updateDelayChart: function() {
        TCApi.call('update_delay_chart', {
            args: {
                manufacturer: this.dashboard.data('manufacturer'),
                logisticsprovider: this.dashboard.data('logisticsprovider')
            }
        }).then(function(res) {
            this.chart_options_delay.xaxis.ticks = res.parcels_list;
            this.parcels_list_all = res.parcels_list_all;
            if (res.min_diff < 0) {
                this.chart_options_delay.yaxis.min = res.min_diff;
            }
            this.delay_datasets[0].bars.barWidth = 0.2;
            this.delay_datasets[0].data = res.data;
            $.plot($('#flot-delay-chart'), this.delay_datasets, this.chart_options_delay);
        }.bind(this));
    },
    setOrderChartControlsEnabled: function(enabled) {
        this.date_from_elem[0].disabled = !enabled;
        this.date_to_elem[0].disabled = !enabled;
    },
    updateOrderChart: function(range) {
        this.setOrderChartControlsEnabled(false);

        var tickSize,
            barWidth,
            date = new Date(),
            thisYear = date.getFullYear(),
            thisMonth = date.getMonth(),
            firstDay = new Date(thisYear, thisMonth, 1),
            lastDay = new Date(thisYear, thisMonth + 1, 0)

        var useProvider = this.dashboard.data('logisticsprovider');

        TCApi.call('update_orders_chart', {
            args: {
                time_range: range,
                date_from: this.orders_from.getFullYear() + '-' + (this.orders_from.getMonth() + 1) + '-' + this.orders_from.getDate(),
                date_to: this.orders_to.getFullYear() + '-' + (this.orders_to.getMonth() + 1) + '-' + this.orders_to.getDate(),
                logisticsprovider: useProvider,
                manufacturer: this.dashboard.data('manufacturer')
            }}).then(function(res) {
                this.chart_options_orders.xaxis.min = res.date_from;
                this.chart_options_orders.xaxis.max = res.date_to;
                this.orders_datasets[0].data = res.data0;
                this.orders_datasets[1].data = res.data1;
                this.orders_datasets[2].data = res.data2;
                switch (range) {
                    case 0:
                        barWidth = 24 * 60 * 60 * 450;
                        this.orders_datasets[0].bars.barWidth =
                        this.orders_datasets[1].bars.barWidth =
                        this.orders_datasets[2].bars.barWidth = barWidth;

                        this.chart_options_orders.xaxis.min -= barWidth;
                        this.chart_options_orders.xaxis.max += barWidth;
                        if (res.data0) {
                            res.data0.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data0.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data1) {
                            res.data1.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data1.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data2) {
                            res.data2.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data2.push([this.chart_options_orders.xaxis.max, null]);
                        }

                        this.chart_options_orders.xaxis.mode = 'time';
                        tickSize = (this.chart_options_orders.xaxis.max - this.chart_options_orders.xaxis.min) / barWidth / 10;
                        this.chart_options_orders.xaxis.tickSize = [Math.max(tickSize, 1), 'day'];
                        this.chart_options_orders.xaxis.tickFormatter = function (val, axis) {
                            var d = new Date(val);
                            var str = d.getUTCDate() + "." + (d.getUTCMonth() + 1);
                            if (tickSize > 50) {
                                str += '.' + d.getFullYear();
                            }
                            return str;
                        };
                        break;
                    case 1:
                        barWidth = 0.7;
                        this.orders_datasets[0].bars.barWidth =
                        this.orders_datasets[1].bars.barWidth =
                        this.orders_datasets[2].bars.barWidth = barWidth;
                        this.chart_options_orders.xaxis.min -= barWidth / 2;
                        this.chart_options_orders.xaxis.max += barWidth / 2;
                        if (res.data0) {
                            res.data0.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data0.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data1) {
                            res.data1.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data1.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data2) {
                            res.data2.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data2.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        this.chart_options_orders.xaxis.mode = null;
                        var tickSize = Math.ceil(this.chart_options_orders.xaxis.max - this.chart_options_orders.xaxis.min) / 10;
                        this.chart_options_orders.xaxis.tickSize = Math.ceil(tickSize);
                        this.chart_options_orders.xaxis.tickFormatter = function (val, axis) {
                            if (val <= this.chart_options_orders.xaxis.min || val >= this.chart_options_orders.xaxis.max) {
                                return '';
                            } else {
                                return val % 52;
                            }
                        }.bind(this);
                        break;
                    case 2:
                        var barWidth = 0.3;
                        this.orders_datasets[0].bars.barWidth =
                        this.orders_datasets[1].bars.barWidth =
                        this.orders_datasets[2].bars.barWidth = barWidth;
                        this.chart_options_orders.xaxis.min -= barWidth / 2;
                        this.chart_options_orders.xaxis.max += barWidth / 2;
                        if (res.data0) {
                            res.data0.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data0.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data1) {
                            res.data1.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data1.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        if (res.data2) {
                            res.data2.splice(0, 0, [this.chart_options_orders.xaxis.min, null]);
                            res.data2.push([this.chart_options_orders.xaxis.max, null]);
                        }
                        this.chart_options_orders.xaxis.mode = null;
                        var tickSize = Math.ceil(this.chart_options_orders.xaxis.max - this.chart_options_orders.xaxis.min) / 10;
                        this.chart_options_orders.xaxis.tickSize = Math.ceil(tickSize);
                        this.chart_options_orders.xaxis.tickFormatter = function (val, axis) {
                            var months = this.dashboard.data('monthshort').split(',');
                            var axisText = '';
                            var month_index = (val - 1) % 12;
                            if (months[month_index] !== undefined) {
                                axisText = months[month_index];
                            }
                            return axisText;
                        }.bind(this);
                        break;
                }

                this.hooks.ordersChartContainer.removeClass('hidden');
                this.hooks.emptyOrdersChartNotify.addClass('hidden');

                $.plot($('#flot-orders-chart'), this.orders_datasets, this.chart_options_orders);
                this.setOrderChartControlsEnabled(true);
            }.bind(this)
        );
    },

    ordersChartRangeChanged: function (e) {
        var button = $(e.target);
        button.siblings().removeClass('btn-primary').addClass('btn-white');
        button.addClass('btn-primary').removeClass('btn-white');
        this.range = button.data('range');
        this.updateOrderChart(this.range);
    },

    showOrdersTooltip: function(event, pos, item) {
        event.preventDefault();
        var tooltipElement = $('#orders-chart-tooltip');

        if (item) {
            var x = item.datapoint[0].toFixed(0),
                y = item.datapoint[1] - item.datapoint[2].toFixed(0),
                text;
            switch (item.seriesIndex) {
                case 0:
                    text = this.dashboard.data('open_orders');
                    break;
                case 1:
                    text = this.dashboard.data('loaded_orders');
                    break;
                case 2:
                    text = this.dashboard.data('not_scheduled');
                    break;
            }
            var d, t;
            switch (this.range) {
                case 0:
                    d = new Date(parseInt(x));
                    t = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
                    break;
                case 1:
                    t = this.dashboard.data('week') + ((parseInt(x)) % 52);
                    break;
                case 2:
                    var months = this.dashboard.data('monthlong').split(',');
                    t = months[(parseInt(x)-1) % 12];
                    break;
            }
            tooltipElement.html(t + ':<br/>' + text + ': ' + y);
        }
    },

    showWaitTooltip: function(event, pos, item) {
        event.preventDefault();
        var tooltipElement = $('#waiting-time-chart-tooltip');

        var x = 0,
            y = 0,
            text = this.dashboard.data('average_waiting_time'),
            t = '';

        if (item) {
            x = item.datapoint[0].toFixed(0);
            y = item.datapoint[1].toFixed(0);

            if (y < 0) {
                text = this.dashboard.data('average_advance');
                y = 0 - y;
            }
            tooltipElement.html('<br>' + text + ': ' + y + this.dashboard.data('minutes'));
        }
    },

    showDelayTooltip: function(event, pos, item) {
        event.preventDefault();
        var tooltipElement = $('#delay-chart-tooltip');

        var x = 0,
            y = 0,
            text = this.dashboard.data('average_delay'),
            t = '';

        if (item) {
            x = item.datapoint[0].toFixed(0);
            y = item.datapoint[1].toFixed(0);
            t = this.parcels_list_all[x][1];

            if (y < 0) {
                text = this.dashboard.data('average_advance');
                y = 0 - y;
            }
            tooltipElement.html(t + ':<br/>' + text + ': ' + y + this.dashboard.data('minutes'));
        }
    }
});